export * from './FoodDrinkCupTakeawayIcon';
export * from './FoodDrinkCupTakeawayIcon16Light';
export * from './FoodDrinkCupTakeawayIcon16Regular';
export * from './FoodDrinkCupTakeawayIcon16Solid';
export * from './FoodDrinkCupTakeawayIcon20Light';
export * from './FoodDrinkCupTakeawayIcon20Regular';
export * from './FoodDrinkCupTakeawayIcon20Solid';
export * from './FoodDrinkCupTakeawayIcon24Regular';
export * from './FoodDrinkCupTakeawayIcon24Solid';
export * from './FoodDrinkCupTakeawayIcon32Regular';
export * from './FoodDrinkCupTakeawayIcon64Regular';
